__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@nackle/deck";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@nackle/biw-web-router", "2.0.5", () => (Promise.all([__webpack_require__.e(240), __webpack_require__.e(979), __webpack_require__.e(558)]).then(() => (() => (__webpack_require__(7240))))));
			register("@nackle/bridge", "3.0.43", () => (Promise.all([__webpack_require__.e(54), __webpack_require__.e(979), __webpack_require__.e(823)]).then(() => (() => (__webpack_require__(3673))))));
			register("@nackle/origami-icons", "1.7.24", () => (Promise.all([__webpack_require__.e(26), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(5026))))));
			register("@nackle/origami", "2.56.25", () => (Promise.all([__webpack_require__.e(930), __webpack_require__.e(355), __webpack_require__.e(979), __webpack_require__.e(113)]).then(() => (() => (__webpack_require__(5355))))));
			register("@nackle/umbrella", "2.1.35", () => (Promise.all([__webpack_require__.e(930), __webpack_require__.e(594), __webpack_require__.e(979), __webpack_require__.e(439)]).then(() => (() => (__webpack_require__(9594))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(8143))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};